import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowRight, Wrench } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TOOL_GROUPS, TOOL_TONES, toolsInGroup } from '../../../const/tools';

const Tools: React.FC = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-16">
    <Helmet>
      <title>Alətlər | 3sual.az</title>
    </Helmet>

    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm px-6 py-5 flex items-center gap-3">
        <div className="w-10 h-10 shrink-0 rounded-xl bg-blue-600 flex items-center justify-center text-white">
          <Wrench className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <h1 className="text-left tracking-normal text-xl font-black text-gray-900 dark:text-gray-50 leading-tight">Alətlər</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">Oyun və turnir keçirmək üçün lazım olan hər şey bir yerdə.</p>
        </div>
      </div>

      {TOOL_GROUPS.map(group => {
        const tools = toolsInGroup(group.id);
        if (tools.length === 0) return null;
        return (
          <section key={group.id} className="space-y-3">
            <div>
              <h2 className="text-left tracking-normal text-base font-bold text-gray-900 dark:text-gray-50">{group.title}</h2>
              <p className="text-sm text-gray-500 dark:text-gray-400">{group.description}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {tools.map(({ id, to, title, description, icon: Icon, tone }) => {
                const c = TOOL_TONES[tone];
                return (
                  <Link
                    key={id}
                    to={to}
                    className={cn(
                      'group flex flex-col rounded-2xl border bg-gradient-to-br p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md',
                      c.card
                    )}
                  >
                    <div className={cn('w-11 h-11 rounded-xl flex items-center justify-center transition-colors', c.tile)}>
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="mt-4 text-lg font-black text-gray-900 dark:text-gray-100 leading-tight">{title}</h3>
                    <p className="mt-1.5 flex-1 text-sm leading-snug text-gray-500 dark:text-gray-400">{description}</p>
                    <span className={cn('mt-4 inline-flex items-center gap-1 text-sm font-semibold', c.link)}>
                      Aç
                      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </Link>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  </div>
);

export default Tools;
